
/* LOCATION */
export const GET_LOCATION_LISTING = "GET_LOCATION_LISTING";
export const GET_LOCATION_LISTING_SUCCESS = "GET_LOCATION_LISTING_SUCCESS";
export const GET_LOCATION_LISTING_FAIL = "GET_LOCATION_LISTING_FAIL";

export const GET_LOCATION_DETAILS = "GET_LOCATION_DETAILS";
export const GET_LOCATION_DETAILS_SUCCESS = "GET_LOCATION_DETAILS_SUCCESS";
export const GET_LOCATION_DETAILS_FAIL = "GET_LOCATION_DETAILS_FAIL";

export const ADD_LOCATION = "ADD_LOCATION";
export const ADD_LOCATION_SUCCESS = "ADD_LOCATION_SUCCESS";
export const ADD_LOCATION_FAIL = "ADD_LOCATION_FAIL";

export const UPDATE_LOCATION = "UPDATE_LOCATION";
export const UPDATE_LOCATION_SUCCESS = "UPDATE_LOCATION_SUCCESS";
export const UPDATE_LOCATION_FAIL = "UPDATE_LOCATION_FAIL";

export const DELETE_LOCATION = "DELETE_LOCATION";
export const DELETE_LOCATION_SUCCESS = "DELETE_LOCATION_SUCCESS";
export const DELETE_LOCATION_FAIL = "DELETE_LOCATION_FAIL";

export const EXPORT_LOCATION = "EXPORT_LOCATION";
export const EXPORT_LOCATION_SUCCESS = "EXPORT_LOCATION_SUCCESS";
export const EXPORT_LOCATION_FAIL = "EXPORT_LOCATION_FAIL";

export const RESET_LOCATION_STATE = 'RESET_LOCATION_STATE';
export const RESET_LOCATION_ATTACHMENT_STATE = 'RESET_LOCATION_ATTACHMENT_STATE';